import { Check } from "lucide-react";
import { MaskedLine, FadeUp } from "@/components/Reveal";
import { PORTRAIT_URL } from "@/data/cases";
import { useLanguage } from "@/i18n/LanguageContext";

export const About = () => {
  const { t } = useLanguage();
  const skills = [t("about.s1"), t("about.s2"), t("about.s3"), t("about.s4"), t("about.s5"), t("about.s6")];

  return (
  <section id="om-mig" data-testid="about-section" className="border-t border-[#262626] bg-[#0A0A0A]">
    <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-16 px-6 py-32 md:px-12 md:py-48 lg:grid-cols-2">
      <FadeUp className="relative order-2 lg:order-1">
        <div className="absolute -inset-8 rounded-[2rem] bg-[#FF3333]/8 blur-3xl" />
        <div className="relative aspect-[4/5] overflow-hidden rounded-[2rem] border border-white/10">
          <img
            src={PORTRAIT_URL}
            alt="Gert — Ny hjemmeside NU"
            data-testid="about-portrait"
            className="h-full w-full object-cover grayscale transition-all duration-700 hover:grayscale-0"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
          <p className="absolute bottom-6 left-6 font-syne text-sm uppercase tracking-[0.3em] text-white/80">
            {t("about.caption")}
          </p>
        </div>
      </FadeUp>

      <div className="order-1 lg:order-2">
        <span className="text-sm uppercase tracking-[0.3em] text-[#FF3333]">{t("about.label")}</span>
        <h2 className="mt-4 font-syne font-extrabold uppercase tracking-tighter text-[#F2F2F2]">
          <MaskedLine innerClassName="text-4xl sm:text-5xl lg:text-6xl">{t("about.h1")}</MaskedLine>
          <MaskedLine delay={0.12} innerClassName="text-4xl sm:text-5xl lg:text-6xl text-stroke">
            {t("about.h2")}
          </MaskedLine>
        </h2>
        <FadeUp delay={0.2}>
          <p className="mt-8 text-base leading-relaxed text-[#A3A3A3] md:text-lg">
            {t("about.p1a")}<span className="text-[#F2F2F2]">Ny hjemmeside NU</span>{t("about.p1b")}
          </p>
          <p className="mt-5 text-base leading-relaxed text-[#A3A3A3] md:text-lg">
            {t("about.p2")}
          </p>
        </FadeUp>
        <FadeUp delay={0.3}>
          <ul data-testid="about-skills-list" className="mt-10 grid grid-cols-2 gap-4">
            {skills.map((s) => (
              <li key={s} className="flex items-center gap-3 text-sm text-[#F2F2F2]">
                <span className="flex h-6 w-6 items-center justify-center rounded-full bg-[#FF3333]/15">
                  <Check className="h-3.5 w-3.5 text-[#FF3333]" />
                </span>
                {s}
              </li>
            ))}
          </ul>
        </FadeUp>
      </div>
    </div>
  </section>
  );
};
